import React, { useState } from "react";
import StatusBadge from "./listing/StatusBadge";

export default function VerifySettlementModal({ open, onClose, data, acc, onUpload }) {
  const [pan, setPan] = useState(null);
  const [cheque, setCheque] = useState(null);

  if (!open) return null;

  const showUpload = data?.status === "pending_doc_upload";

  return (
    <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50">
      <div className="bg-white dark:bg-slate-800 p-5 rounded-lg w-[400px]">
        <h2 className="font-bold text-lg">Settlement Verification</h2>

        <p>Name: {acc?.accountHolderName}</p>
        <p className="flex items-center gap-2 mt-1">
          Status: <StatusBadge status={data?.status} />
        </p>

        {showUpload && (
          <>
            <input type="file" onChange={(e) => setPan(e.target.files[0])} />
            <input type="file" onChange={(e) => setCheque(e.target.files[0])} />

            <button
              onClick={() => onUpload(pan, cheque)}
              className="bg-green-600 text-white px-3 py-2 mt-2 rounded"
            >
              Upload Docs
            </button>
          </>
        )}

        <button onClick={onClose} className="bg-gray-300 px-3 py-2 mt-2 rounded">
          Close
        </button>
      </div>
    </div>
  );
}
